export enum BusinessType {
    OPERATOR = 'operator',
    RESELLER = 'reseller',
}
